import React from "react";
import ResumeContent from "./ResumeContent";
import ResumeSidebar from "./ResumeSidebar";
import IconFaDownload from "../img/IconFaDownload";

function ResumeView() {
  return (
    <>
      <h2 className="cv-heading">
        <a
          className="cv-download-link"
          href="http://martinduggan.com/folio20/resume-ux-martin-duggan-20.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
            Resume <IconFaDownload />
          </span>
        </a>
      </h2>
      <section className="cv-layout">
        <article className="cv-experience">
          <h3 class="cv-title">experience</h3>
          <ResumeContent />
        </article>
        <aside class="cv-quals">
          <h3 class="cv-title">skills</h3>
          <ResumeSidebar />
        </aside>
      </section>
    </>
  );
}

export default ResumeView;
